<template>
  <div id="app">
    <h4><small> {{ title }} </small></h4>
    <div style="display: none;"> {{ plant }} </div>
    <highcharts :options="chartOptions" ref='chart'></highcharts>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Vue from 'vue'
import axios from 'axios';
import mixin from '../../../../utils/mixin'

export default {
  name: 'charts',
  props: {
    title: {
      type: String
    },
    plant: {
      type: Number
    },
    data: {
      type: Array, // [serie1, serie2]
    }
  },
  data () {
    return {
      titleChart: this.$t("223"),
      tableData: [],
      type: 'line',
      chartOptions: {
        colors: ['#e4d354', '#f0893a', '#f45b5b', '#f45b5b'],
        chart: {
          type: 'line',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063'
        },
        title: {
            text: '',
            style: {
                color: '#E0E0E3',
                textTransform: 'uppercase',
                fontSize: '16px',
                fontWeight: 'bold'
            }
        },
        subtitle: {
            style: {
                color: '#E0E0E3',
                textTransform: 'uppercase'
            }
        },
        xAxis: {
            categories: [
              'R1',
              'R2',
              'R3',
              'R3+'
            ],
            crosshair: true,
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#E0E0E3'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            title: {
                style: {
                    color: '#A0A0A3'
                }
            }
        },
        yAxis: [{
            labels: {
                format: '{value}%',
            },
            title: {
                text: this.$t("299"),
                style: {
                    color: '#A0A0A3',
                    fontSize: '12px',
                }
            },
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#E0E0E3'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            tickWidth: 1,
          },
          {
            title: {
                text: this.$t("299"),
                style: {
                    color: '#A0A0A3',
                    fontSize: '12px',
                }
            },
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#E0E0E3'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            tickWidth: 1,
            opposite: true
        }],
        tooltip: {
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            style: {
                color: '#F0F0F0'
            },
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y} </b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                    color: '#F0F0F3',
                    style: {
                        fontSize: '13px'
                    }
                },
                cursor: 'pointer',
                marker: {
                    lineColor: '#333'
                },
                events:{
                    click: this.loadGrid
                },
                // cursor: 'pointer'
            },
            boxplot: {
                fillColor: '#505053'
            },
            candlestick: {
                lineColor: 'white'
            },
            errorbar: {
                color: 'white'
            },
            column: {
                pointPadding: 0.1,
                borderWidth: 0
            }
        },
        legend: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            itemStyle: {
                color: '#E0E0E3'
            },
            itemHoverStyle: {
                color: '#FFF'
            },
            itemHiddenStyle: {
                color: '#606063'
            },
            title: {
                style: {
                    color: '#C0C0C0',
                    fontSize: '12px'
                }
            }
        },
        labels: {
            style: {
                color: '#707073'
            }
        },
        drilldown: {
            activeAxisLabelStyle: {
                color: '#F0F0F3'
            },
            activeDataLabelStyle: {
                color: '#F0F0F3'
            }
        },
        navigation: {
            buttonOptions: {
                symbolStroke: '#DDDDDD',
                theme: {
                    fill: '#505053'
                }
            }
        },
        // scroll charts
        rangeSelector: {
            buttonTheme: {
                fill: '#505053',
                stroke: '#000000',
                style: {
                    color: '#CCC'
                },
                states: {
                    hover: {
                        fill: '#707073',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    },
                    select: {
                        fill: '#000003',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    }
                }
            },
            inputBoxBorderColor: '#505053',
            inputStyle: {
                backgroundColor: '#333',
                color: 'silver'
            },
            labelStyle: {
                color: 'silver'
            }
        },
        navigator: {
            handles: {
                backgroundColor: '#666',
                borderColor: '#AAA'
            },
            outlineColor: '#CCC',
            maskFill: 'rgba(255,255,255,0.1)',
            series: {
                color: '#7798BF',
                lineColor: '#A6C7ED'
            },
            xAxis: {
                gridLineColor: '#505053'
            }
        },
        scrollbar: {
            barBackgroundColor: '#808083',
            barBorderColor: '#808083',
            buttonArrowColor: '#CCC',
            buttonBackgroundColor: '#606063',
            buttonBorderColor: '#606063',
            rifleColor: '#FFF',
            trackBackgroundColor: '#404043',
            trackBorderColor: '#404043'
        },
        series: [{
            name: this.$t("300"),
            type: 'column',
            yAxis: 1,
            data: this.data[0],
            colorByPoint: true
          }, {
            name: this.$t("301"),
            type: 'spline',
            data: this.data[1],
            tooltip: {
                valueSuffix: '%'
            },
            color: '#fff',
        }],
        exporting: { enabled: false },
        credits: {
          enabled: false
        },
        loading: {
            labelStyle: {
                color: 'black',
                textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
            },
            style: {
                backgroundColor: 'none',
                opacity: 1,
            }
        },
      },
    }
  },
  mixins: [mixin],
  methods: {
    ...mapMutations(['changeGrid']),

    loadGrid(event){
        let total = event.point.y
        //console.log('total: ', total)
        if(total != 0){        

            if(this.getTab == 'offline'){

                let region = this.filters.region  ? '' : this.title
                //console.log('region: ', region)

                let plant = this.filters.region  ? this.plant : ''
                //console.log('plant: ', plant)             

                let status = event.point.category
                let date = event.point.category;
                let point_name = event.point.series.name;
                let NAME_CHART = this.$t("359") + ' - ' + point_name.toUpperCase()

                const ENDPOINT = `v1/mysemeq-ambev/get-reports-repetition?plant=${plant}&region=${region}&status=${status}&technique=${this.filters.technique}&year=${this.filters.year}&period=${this.filters.period}&area=${this.filters.area}&sector=${this.filters.sector}&machine=${this.filters.machine}&component=${this.filters.component}&online=0`

                let grid = {
                    totalDados: event.point.y,
                    title: this.title+' '+event.point.series.name,
                    url: ENDPOINT,
                    name_chart: NAME_CHART,
                    columns: {
                            "rows": '',
                            "plant": this.$t("310"),
                            "area": this.$t("311"),
                            "sector": this.$t("312"),
                            "component": this.$t("313"),
                            "component_tag": this.$t("314"),
                            "component_type_en": this.$t("315"),
                            "machine": this.$t("316"),
                            "machine_tag": this.$t("317"),
                            "technique_en": this.$t("321"),
                            "report_number": this.$t("319"), 
                            "approved_datetime": this.$t("320"),
                            "link": this.$t("323"),
                            "link_rci": this.$t("324"),
                            "pending_days": this.$t("325"),
                            "delay": this.$t("326"),
                            "prescription_created_datePtime": this.$t("327"), 
                            "week": this.$t("328"),
               
                        },
                        show: true,
                        titleHelp: 'Grid - ' + this.$t("359"),
                        txtHelp: this.$t("357")
                    }

                    if (this.filters.plant) {
                        grid.title += ' - ' + this.filters.plant_name
                        delete grid.columns['plant']
                    } else if (this.filters.region){
                        grid.title += ' - ' + this.filters.region
                    }

                    // console.log(grid);

                    this.changeGrid(grid);

            }
            if(this.getTab == 'online'){

                let region = this.filtersOn.region  ? '' : this.title
                //console.log('region: ', region)

                let plant = this.filtersOn.region  ? this.plant : ''
                //console.log('plant: ', plant)
             

                let status = event.point.category
                let date = event.point.category;
                let point_name = event.point.series.name;
                let NAME_CHART = this.$t("359") + ' - ' + point_name.toUpperCase()


                const ENDPOINT = `v1/mysemeq-ambev/get-reports-repetition?plant=${plant}&region=${region}&status=${status}&technique=&year=${this.filtersOn.year}&period=${this.filtersOn.period}&area=${this.filtersOn.area_f}&sector=${this.filtersOn.sector_f}&machine=${this.filtersOn.machine}&component=${this.filtersOn.subset}&online=1`

                let grid = {
                    totalDados: event.point.y,
            title: this.title+' '+event.point.series.name,
            url: ENDPOINT,
            name_chart: NAME_CHART,
            columns: {
                    "rows": '',
                    "plant": this.$t("310"),
                    "area": this.$t("311"),
                    "sector": this.$t("312"),
                    "component": this.$t("313"),
                    "component_tag": this.$t("314"),
                    "component_type_en": this.$t("315"),
                    "machine": this.$t("316"),
                    "machine_tag": this.$t("317"),
                    "technique_en": this.$t("321"),
                    "report_number": this.$t("319"), 
                    "approved_datetime": this.$t("320"),
                    "link": this.$t("323"),
                    "link_rci": this.$t("324"),
                    "pending_days": this.$t("325"),
                    "delay": this.$t("326"),
                    "prescription_created_datePtime": this.$t("327"), 
                    "week": this.$t("328"),
                },
                show: true,
                titleHelp: 'Grid - ' + this.$t("359"),
                txtHelp: this.$t("357")
            }

            if (this.filters.plant) {
                grid.title += ' - ' + this.filters.plant_name
                delete grid.columns['plant']
            } else if (this.filters.region){
                grid.title += ' - ' + this.filters.region
            }

            // console.log(grid);

            this.changeGrid(grid);

            }
        //fim se total != 0    
        }  

    },
  },
  computed: {
    soma: function(){
      let soma = this.chartOptions.series[0].data

      soma = soma.reduce(function(total, num) {
        return total + num;
      }, 0);
      return soma;

    },
    ...mapGetters(['filters','filtersOn', 'getTab']),
  },
  mounted() {
    if (this.soma <= 0)
      this.$refs.chart.chart.showLoading('No data!');
  }
}
</script>
<style scoped>
tspan {
  stroke: none!important;
  stroke-width: 1px;
  stroke-linejoin: round;
}
.highcharts-drilldown-data-label text{
  text-decoration:none !important;
}

h4 small{
  color: #ffffff;
  text-align: center;
  display: block;
  padding-top: 8px
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Charts/ReincidenciaChart.vue